<template>
  <div class="c-select-wbsb">
    <el-select
      v-model="norm.monoidal"
      :filterable="filterable"
      :clearable="clearable"
      :disabled="disabled"
      :size="size"
      value-key="value"
      placeholder="请选择系统"
      @change="handleChangeMonoidal"
    >
      <el-option
        v-if="showAll"
        label="全部"
        :value="null"
      />
      <el-option
        v-for="item in xtType"
        :key="item.value"
        :label="item.text"
        :value="item.id"
      />
    </el-select>
    <el-select
      v-model="norm.subkey"
      :filterable="filterable"
      :clearable="clearable"
      :disabled="disabled"
      :size="size"
      value-key="value"
      placeholder="请选择设备"
      @change="handleChangeubkey"
    >
      <el-option
        v-if="showAll"
        label="全部"
        :value="null"
      />
      <el-option
        v-for="item in normOption.subkey"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import { xfsbService } from '../../xfjcgl/xmgl/xfsb/xfsb.service';
export default {
  name: 'SelectSb',
  props: {
    apiPath: {
      type: String,
      default: ''
    },
    // 输入框尺寸
    size: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'wb' // 维保wb、检测jc 、评估 pg
    },
    // 默认数据
    value: {
      type: String,
      default: null
    },
    // 是否可搜索
    filterable: {
      type: Boolean,
      default: true
    },
    // 是否可清空选项
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择地址'
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      normApiPath: `${this.$config.ctx.iffApi}/norm`,
      norm: {
        monoidal: null,
        subkey: null
      },
      normOption: {
        monoidal: [], // 系统
        subkey: [] // 设备
      }
    };
  },
  computed: {
    // 系统
    xtType () {
      const _normType = {
        wb: 'IFF_WBNRLX',
        jc: 'IFF_JC_JCNR',
        pg: 'IFF_AQLB'
      };
      const _type = _normType[this.type];
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums[_type]) {
        return enums[_type];
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 切换系统，重新获取设备
     * @param {*} val
     * @return {*}
     */
    handleChangeMonoidal (val) {
      this.norm.subkey = null;
      this.normOption.subkey = [];

      if (val && this.type === 'pg') {
        this.handlePgQuerynorm('subkey', val);
      } else if (val && this.type === 'jc') {
        this.handleJcQuerynorm('subkey', val);
      } else if (val) {
        this.handleWbQuerynorm('subkey', val);
      }
      if (!this.required) {
        const norm = this.handleObjectValues(this.norm).join('/');
        this.$emit('input', norm);
      } else {
        this.$emit('input', null);
      }
    },
    /**
     * @description: 切换设备
     * @param {*} val
     * @return {*}
     */
    handleChangeubkey (val) {
      const norm = this.handleObjectValues(this.norm).join('/');
      this.$emit('input', norm);
    },
    handleObjectValues (_object) {
      const props = Object.keys(Object(_object));
      const _values = props.map((key) => _object[key]);
      return _values;
    },
    /**
     * @description: 获取维保标准内容
     * @param {*} type subkey：子项
     * @param {*} code 单项编码
     * @return {*}
     */
    handleWbQuerynorm (type, code) {
      return this.$axios.get(`${this.$config.ctx.iffApi}/xfwb/xccs/query/wbsb`, { params: { xfxtId: code } })
        .then(rsp => {
          this.normOption[type] = rsp.data.map(element => {
            return { value: element.xfsbId, label: element.xfsbMc };
          });
          // 去重
          const set = new Set();
          this.normOption[type] = this.normOption[type].filter(item => {
            if (!set.has(item.label)) {
              set.add(item.label);
              return item;
            }
          });
        })
        .catch(err => {
          console.error(type + '加载失败！', err);
        });
    },
    /**
     * @description: 获取评估设备标准内容
     * @param {*} type subkey：子项
     * @param {*} code 单项编码
     * @return {*}
     */
    handlePgQuerynorm (type, code) {
      return this.$axios.get(`${this.$config.ctx.iffApi}/xfpg/pgwt/query/xmdx/${code}`)
        .then(rsp => {
          this.normOption[type] = rsp.data.map(element => {
            return { value: element.dxzbId, label: element.dxzbMc };
          });
        })
        .catch(err => {
          console.error(type + '加载失败！', err);
        });
    },
    /**
     * @description: 获取标准内容
     * @param {*} type subkey：子项
     * @param {*} code 单项编码
     * @return {*}
     */
    handleJcQuerynorm (type, code) {
      xfsbService.getJcdByJcnrId(code)
        .then(rsp => {
          this.normOption[type] = rsp.data.map(element => {
            return { value: element.jcdId, label: element.jcdMc };
          });
        })
        .catch(err => {
          console.error(`${type}加载失败!`, err);
        });
    },
    getSbMc () {
      const xtArray = Object.values(this.xtType);
      let xfxtmc = '';
      for (const item of xtArray) {
        if (item.id === this.norm.monoidal) {
          xfxtmc = item.text;
          break;
        }
      }
      let xfsbmc = '';
      for (const item of this.normOption.subkey) {
        if (item.value === this.norm.subkey) {
          xfsbmc = item.label;
          break;
        }
      }
      return [
        xfxtmc,
        xfsbmc
      ];
    },
    // 解析默认地址
    handleAnalysisValue (_init) {
      if (!this.value) return;
      let norm = '';
      try {
        norm = this.value.split('/') || [];
      } catch (error) {
        console.log('系统设备不合规范:' + error);
      }
      const dataFormat = norm instanceof Array;
      if (!dataFormat) return;
      [
        this.norm.monoidal,
        this.norm.subkey
      ] = norm;

      if (this.norm.monoidal) {
        if (this.type === 'pg') {
          this.handlePgQuerynorm('subkey', this.norm.monoidal);
        } else if (this.type === 'jc') {
          this.handleJcQuerynorm('subkey', this.norm.monoidal);
        } else {
          this.handleWbQuerynorm('subkey', this.norm.monoidal);
        }
      }
    }
  },
  watch: {
    value: {
      handler (newValue, oldValue) {
        if (newValue && !this.norm.monoidal) {
          this.handleAnalysisValue();
        } else if (!newValue && oldValue) {
          this.norm.monoidal = null;
          this.norm.subkey = null;
        }
      },
      deep: true
    }
  },
  async created () {
    this.handleAnalysisValue();
  }
};
</script>

<style lang="scss">
.c-select-wbsb {
  display: flex;
  justify-content: space-between;

  .el-select {
    flex: 0.5;

    & + .el-select {
      margin-left: 4px;
    }
  }
}
</style>
